import React, { useState } from 'react';

export default function UploadButton({onChange, defaultFile=null}) {
    const [file, setFile] = useState(defaultFile);

    const handleFileChange = (e) => {
        const upFile = e.target.files[0];

        setFile(upFile);

        if (onChange)
            onChange(upFile);
    };

    function displayFileName() {
        if (file)
          return (file.name || file.filename)
        else
            return ("Téléverser signé")
    }
    
    const active = file?.name || file?.filename ? "active" : "";

    return (
        <div>
            <label className={`custom-btn-uploadfile ${active}`}>
                <span>{displayFileName()}</span>
                <input
                    type="file"
                    onChange={handleFileChange}
                    className="d-none"
                />
            </label>      
        </div>
    );
}